var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ApiPropertyOptional } from "@nestjs/swagger";
import { IsDate, IsOptional } from "class-validator";
export class CompositeUpdatedAtDto {
}
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "loginTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "loginText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "welcomeTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "welcomeText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "dataUpdateWelcomeTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "dataUpdateWelcomeText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "californiaBillOfRightsTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "californiaBillOfRightsText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "studyInformationTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "purposeOfResearchTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "lengthOfStudyNumberOfParticipantsTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "lengthOfStudyNumberOfParticipantsText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "healthRecordUpdatesTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "healthRecordUpdatesText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "proceduresAndInterventionsTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "timelineTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "benefitsTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "risksTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "voluntaryParticipationTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "voluntaryParticipationText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "withdrawalImplicationsTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "injuryProtocolTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "participationTerminationTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "dataTypesTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "sensitiveDataTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "sensitiveDataText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "futureUseOfDataTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "confidentialityMeasuresTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "compensationTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "costTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "researchResultsTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "whoToContactTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "whoToContactText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "informedConsentTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "informedConsentText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "informedConsentYesText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "informedConsentNoText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "informedConsentInterestedText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "hipaaTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "hipaaText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "hipaaOrganizationLegalName", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "hipaaAuthorizationText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "informedConsentStatement", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "thankYouConsentedTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "thankYouConsentedText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "dataUpdateThankYouConsentedTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "dataUpdateThankYouConsentedText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "thankYouDeclinedTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "thankYouDeclinedText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "thankYouImInterestedTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "thankYouImInterestedText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "parentGuardianTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "parentGuardianInstructions", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "parentGuardianSignatureTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "parentGuardianInformedConsentStatement", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "additionalParentGuardianTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "additionalParentGuardianInstructions", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "additionalParentGuardianExemptSignatureText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "additionalParentGuardianSignatureTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "additionalParentGuardianInformedConsentStatement", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "minorParticipantTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "minorParticipantInstructions", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "minorParticipantExemptFromAssentText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "minorParticipantAssentTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "minorParticipantAssentStatement", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "participantTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "participantInstructionsForGuidedConsent", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "purposeOfResearchText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "larTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "larInstructions", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "larSignatureTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "larInformedConsentStatement", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "larParticipantTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "larParticipantInstructions", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "larParticipantExemptFromAssentText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "larParticipantAssentTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "larParticipantAssentStatement", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "witnessTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "witnessInstructions", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "witnessSignatureTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "witnessConfirmation", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "providerTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "providerInstructions", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "providerSignatureTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "providerConfirmation", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "proceduresAndInterventionsText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "informedConsentPrimaryDiseaseOrConditions", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "patientFriendlyTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "patientFriendlySummary", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "informedConsentIRBApprovalStamp", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "risksOfEnrollment", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "benefitsOfEnrollment", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "leavingStudyEarlyText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "injuryProtocolText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "participationTerminationText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "futureUseOfData", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "futureUseOfDataText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "confidentialityOfDataText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "compensationText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "costOfParticipationText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "sharingResultsText", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "alternativesToParticipation", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "timelineVisitPeriods", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "timelineVisitDescriptions", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "introTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "introPurposeOfDisclosure", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "introBriefEducation", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "patientHealthRecordRightsTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "contactDetails", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "purposeOfDataTitle", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "purposeOfDataBriefEducation", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "aiToolName", void 0);
__decorate([
    ApiPropertyOptional(),
    IsOptional(),
    IsDate(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "aiExplanationOfHealthEx", void 0);
__decorate([
    ApiPropertyOptional(),
    IsDate(),
    IsOptional(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "explanationOfDataProtection", void 0);
__decorate([
    ApiPropertyOptional(),
    IsDate(),
    IsOptional(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "aiExplanationOfDataUseByLegalOrg", void 0);
__decorate([
    ApiPropertyOptional(),
    IsDate(),
    IsOptional(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "aiExplanationOfFees", void 0);
__decorate([
    ApiPropertyOptional(),
    IsDate(),
    IsOptional(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "aiAuthToShare", void 0);
__decorate([
    ApiPropertyOptional(),
    IsDate(),
    IsOptional(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "aiAuthToShareExplanation", void 0);
__decorate([
    ApiPropertyOptional(),
    IsDate(),
    IsOptional(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "timeToConnectInformation", void 0);
__decorate([
    ApiPropertyOptional(),
    IsDate(),
    IsOptional(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "aiToolTermsUrl", void 0);
__decorate([
    ApiPropertyOptional(),
    IsDate(),
    IsOptional(),
    __metadata("design:type", Object)
], CompositeUpdatedAtDto.prototype, "aiToolIcon", void 0);
